import { css } from 'styled-components';
import {
  getSpacing,
  ThemedFunctor,
  SpacingName,
  BreakpointQueryName,
} from '@doveit/lego';

export const heroActions: ThemedFunctor = ({
  theme,
}) => css`
    ${theme.breakpoints.up(BreakpointQueryName.LG)} {
      justify-content: center;
    }
`;

export const content: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.paddingBottom(theme, SpacingName.BIGGER)}
`;
